<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Related_person_types/elements/Title.vue'

export default {
  name: 'RelatedPersonTypeForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
